<ng-container *ngIf="editMode">
  <p-skeleton height="32px" [width]="minWidth" styleClass="skeleton-with-border" *ngIf="!indicateursLoaded"></p-skeleton>
  <p-dropdown
    scrollHeight="400px"
    inputId="indicateursDropdown{{ guid }}"
    name="indicateursDropdown{{ guid }}"
    [options]="indicateurs"
    [(ngModel)]="indicateur"
    [required]="required"
    [disabled]="disabled"
    dataKey="Id"
    [showClear]="showClear"
    [resetFilterOnHide]="true"
    [emptyFilterMessage]="'Aucun résultat'"
    appendTo="body"
    [placeholder]="placeholder"
    emptyMessage="Aucun résultat trouvé"
    [autoDisplayFirst]="false"
    [style]="pDropdownStyle"
    #indicateurCtrl="ngModel"
    (ngModelChange)="indicateurChanged()"
    *ngIf="indicateursLoaded"
    styleClass="no-ellipsis"
  >
    <ng-template let-item pTemplate="selectedItem">
      <span>{{ item?.CodeNom }}</span>
    </ng-template>
    <ng-template let-item pTemplate="item">
      <div class="ui-helper-clearfix">
        <span>{{ item.CodeNom }}</span>
      </div>
    </ng-template>
  </p-dropdown>
</ng-container>
<ng-container *ngIf="_indicateur && !editMode">
  <span>{{ _indicateur.CodeNom }}</span>
</ng-container>
